export const wordLists = [
  "JavaScript",
  "Custom Animation",
  "React Native",
  "Flutter",
  "Developer Experience",
  "Stack Overflow",
  "Frontend Engineer",
  "UI/UX Designer",
  "MacBook Pro",
  "External Display",
  "Desktop Application",
  "Universal Web Connector",
  "DOM Manipulation",
  "CSS Animation",
  "Technical Experience",
  "Native Application",
  "MVP",
  "Test Automation",
  "Responsive Design",
  "Frontend Ninga",
  "Windows",
  "Linux System",
  "Screen Cast",
  "Access Control",
  "Database",
]
